export default __webpack_public_path__ + "static/media/BluePlayerDanceMin.cc23d50f.png";